export const DATE_TIME = {
  GET_UTC_TIME: 'GET_UTC_TIME',
}
